import { createContext } from 'react';
import { memoryStore } from './memoryStore';
var defaultStore = memoryStore();
export var StoreContext = createContext(defaultStore);
//# sourceMappingURL=StoreContext.js.map